import { SVGProps } from "react";

const EnvelopeEmailIcon = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2197_2985)">
        <g clipPath="url(#clip1_2197_2985)">
          <path
            d="M1.13227 1.62451C1.29857 1.54337 1.48098 1.50065 1.66602 1.49951H9.16602C9.35105 1.50065 9.53347 1.54337 9.69977 1.62451L5.69977 5.26535C5.62191 5.33501 5.52111 5.37352 5.41664 5.37352C5.31217 5.37352 5.21137 5.33501 5.13352 5.26535L1.13227 1.62451ZM8.32852 6.49951H8.33268C8.33257 6.25817 8.40247 6.02197 8.53391 5.81955C8.66534 5.61713 8.85267 5.45719 9.07319 5.3591C9.2937 5.26102 9.53794 5.229 9.77628 5.26694C10.0146 5.30488 10.2369 5.41114 10.416 5.57284V2.74951C10.4153 2.56349 10.3726 2.38004 10.291 2.21284L6.95768 5.24909L8.32852 6.49951ZM0.541016 2.21284C0.459477 2.38004 0.416747 2.56349 0.416016 2.74951V7.74951C0.416747 7.93553 0.459477 8.11898 0.541016 8.28618L3.87727 5.24951L0.541016 2.21284ZM6.33602 5.81201L6.25852 5.88284C6.02747 6.09074 5.72766 6.20576 5.41685 6.20576C5.10604 6.20576 4.80623 6.09074 4.57518 5.88284L4.49602 5.81034L1.13227 8.87451C1.29863 8.95546 1.481 8.99817 1.66602 8.99951H5.41602V7.74951C5.41602 7.41799 5.54771 7.10005 5.78213 6.86563C6.01655 6.63121 6.3345 6.49951 6.66602 6.49951H7.09102L6.33602 5.81201ZM11.961 8.28826L9.87768 6.20493C9.81943 6.14653 9.74516 6.10674 9.66428 6.09058C9.58339 6.07443 9.49953 6.08265 9.42332 6.1142C9.34711 6.14574 9.28198 6.1992 9.23617 6.26779C9.19037 6.33638 9.16595 6.41703 9.16602 6.49951V7.33284H6.66602C6.55551 7.33284 6.44953 7.37674 6.37139 7.45488C6.29325 7.53302 6.24935 7.639 6.24935 7.74951V9.41618C6.24935 9.52668 6.29325 9.63267 6.37139 9.71081C6.44953 9.78895 6.55551 9.83284 6.66602 9.83284H9.16602V10.6662C9.16603 10.7486 9.19048 10.8291 9.23627 10.8976C9.28205 10.9661 9.34712 11.0195 9.42324 11.051C9.49937 11.0826 9.58313 11.0908 9.66395 11.0748C9.74476 11.0587 9.81899 11.019 9.87727 10.9608L11.9606 8.87743C12.0387 8.79929 12.0826 8.69333 12.0826 8.58284C12.0826 8.47236 12.0391 8.3664 11.961 8.28826Z"
            fill="black"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2197_2985">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(0.75 0.5)"
          />
        </clipPath>
        <clipPath id="clip1_2197_2985">
          <rect
            width="12"
            height="9.33333"
            fill="white"
            transform="translate(0.25 1.83301)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default EnvelopeEmailIcon;
